<style lang="scss" scoped="">


</style>

<template>
	<div class="container">
		<p style=""></p>
		<el-form size="mini" :inline="true" :model="historyParams" class="demo-form-inline">

			<el-form-item :label="$t('chuangjianshijian')">
				<yi_time_input :maxTime="7 * 24 * 3600 * 1000" type="datetimerange"
					:start.sync="historyParams.startTime" :end.sync="historyParams.endTime"
					>
				</yi_time_input>
			</el-form-item>

			<el-form-item>
				<el-button @click="getHistory()" type="primary" plain="plain">
					{{$t('sousuo')}}
				</el-button>
				<el-button @click="clear()">
					{{$t('chongzhi')}}
				</el-button>
			</el-form-item>
		</el-form>
		<el-tabs v-model="currentTab" @tab-click="handleClick">
			<el-tab-pane :label="$t('fenxitu')" name="fenxitu"></el-tab-pane>
			<el-tab-pane :label="$t('xiangqing')" name="xiangqing"></el-tab-pane>
		</el-tabs>
		<div v-if="datas" style="padding-bottom: 40px;">
			<div v-show="currentTab=='fenxitu'">
				<div style="display: flex;align-items: center;">
					<div style="width: 5px;height: 16px;background: #419FFF;"></div>
					<div style="font-size: 16px;color: #303133;margin-right: 16px;margin-left: 12px;">{{$t('yangbenshu')}}：{{datas.total}}</div>
					<div style="font-size: 16px;color: #303133;margin-right: 16px;">{{$t('zuidazhi')}}：{{datas.max}}</div>
					<div style="font-size: 16px;color: #303133;margin-right: 16px;">{{$t('zuixiaozhi')}}：{{datas.min}}</div>
					<div style="font-size: 16px;color: #303133;margin-right: 16px;">{{$t('zhongweishu')}}：{{datas.mid}}</div>
				</div>
				<div id="technologyDetailChart" style="height: 420px;margin-top: 10px;">

				</div>
			</div>
			<div v-show="currentTab=='xiangqing'">

				<el-table ref="table" :row-style="{height:42+'px'}" :cell-style="{padding:0+'px'}"
					:header-cell-style="{background:'#F5F7FA',color:'#606266','font-weight':'700', height:'48px', padding:'0px'}"
					stripe row-key="id" :data="datas.list" style="width: 100%" highlight-current-row border
					size="medium" :max-height="420">
					<el-table-column :label="$t('caijishijian')">
						<template slot-scope="scope">
							{{ dayjs(scope.row.time).format('YYYY-MM-DD HH:mm:ss') }}
						</template>
					</el-table-column>
					<el-table-column :label="$t('zhi')">
						<template slot-scope="scope">
							{{ scope.row.fvalue }}
						</template>
					</el-table-column>
				</el-table>

			</div>
		</div>

		<!-- {{store.state.eqPoints[equipment.id][tapCode]}} -->
	</div>

</template>
<script type="text/javascript">
	export default {
		name: 'web_monitor_equipment_statistics_tabs_technology_technology_detail',
		components: {

		},
		props: {
			equipment: {
				type: Object,
				default: function() {
					return {}
				},
			},
			tapCode: {
				type: String,
				default: null,
			},
		},
		data() {
			return {
				technologyDetailChart:null,
				option1:null,
				currentTab: 'fenxitu',
				historyParams: {
					equipmentId: this.equipment.id,
					code: this.tapCode,
					startTime: this.dayjs().startOf('day').valueOf(),
					endTime: (new Date()).getTime(),
				},
				datas: null,
			};
		},

		watch: {
			tapCode: {
				handler(newVal, oldVal) {
					this.historyParams = {
						equipmentId: this.equipment.id,
						code: this.tapCode,
						startTime: this.dayjs().startOf('day').valueOf(),
						endTime: (new Date()).getTime(),
					}
					this.getHistory()
				},
				immediate: true
			}
		},
		created() {

		},
		computed: {


		},
		mounted() {
			this.resize()
			this.utils.event_hub.$on('RESIZE', () => {
				this.resize();
			});


		},
		destroyed() {},
		methods: {
			handleClick(e) {

			},
			resize() {
				//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
				setTimeout(() => {

				}, 500)
			},
			inittechnologyDetailChart() {

				this.option1 = {
					grid: {
						left: '0',
						right: '20',
						bottom: '0',
						top: '10',
						containLabel: true,
					},
					tooltip: {
						trigger: 'axis',
						formatter:(param) =>{
							let title = this.dayjs(parseInt(param[0]['axisValueLabel'])).format('HH:mm:ss')
							let label = ''
							for (let i = 0; i < param.length; i++) {
								label += '\n' + param[i]['marker'] + this.$t('shijizhi') + '   ' + param[i]['value'].toFixed(1) + '\n' + ' '
							}
							return title + '\n' + label
						},
						extraCssText: 'width:150px; white-space:pre-wrap;font-weight:bold',
					},
					xAxis: {
						type: 'category',
						data: this.technologyDetailChartTimes,
						axisLabel: {
							show: true,
							textStyle: {
								color: '#909399', //更改坐标轴文字颜色
								fontSize: 12 //更改坐标轴文字大小
							},
							formatter: (value,index)=>{
								return this.dayjs(parseInt(value)).format('HH:mm:ss')
							},
						},
						axisLine: {
							lineStyle: {
								color: '#DCDFE6', //更改坐标轴文字颜色
							}
						},
						axisTick: {
							inside: false
						},

					},
					yAxis: {
						show: true,
						type: 'value',
						axisLabel: {
						textStyle: {
							color: '#909399', //更改坐标轴文字颜色
							fontSize: 12 //更改坐标轴文字大小
						},
						}
					},
					series: [{
						data: this.technologyDetailChartValues,
						type: 'line',
						symbol: 'none',
						itemStyle: {
							normal: {
								color: '#419FFF',
								barBorderRadius: 6,
							},
						},
					}]
				};
				var chartDom = document.getElementById('technologyDetailChart');
				this.technologyDetailChart = this.echarts.init(chartDom);
				this.option1 && this.technologyDetailChart.setOption(this.option1);
			},

			clear() {
				this.historyParams = {
					equipmentId: this.equipment.id,
					code: this.tapCode,
					startTime: this.dayjs().startOf('day').valueOf(),
					endTime: (new Date()).getTime(),
				}
				this.getHistory()
			},
			getHistory() {
				this.http.get('web/equipment/craft/history', {
					params: this.historyParams
				}).then(res => {
					this.datas = res.data
					this.technologyDetailChartTimes = this.datas.list.map(item => {
						return item.time
					})
					this.technologyDetailChartValues = this.datas.list.map(item => {
						return item.fvalue
					})
					if(this.technologyDetailChart){
						this.technologyDetailChart.dispose();
						this.technologyDetailChart = null
					}

					setTimeout(()=>{
						if (!this.technologyDetailChart) {
							this.inittechnologyDetailChart()
						}
					},300)
				})

			}

		}
	};
</script>
